import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteReportSnapshot } from "@services/reportEngine";

export const useDeleteReportSnapshot = () => {
  const queryClient = useQueryClient();

  return useMutation((id: string) => deleteReportSnapshot(id), {
    onSuccess: () => queryClient.invalidateQueries(["reportSnapshots"]),
  });
};
